export enum PlpPageRouteEnum {
  HARD_SURFACE = 'hardsurface',
  ACCESSORIES = 'accessories',
  CARPET = 'carpet',
  SEARCH = 'search'
}

export enum ProductClassificationEnum {
  HARD_SURFACE = 'HardSurface',
  ACCESSORIES = 'Accessories',
  SOFT_SURFACE = 'SoftSurface'
}
